import { FileText, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { useLanguage } from '@/contexts/AppContext';
import type { Company, TaxInvoiceTranslations } from './types';
import { loadingMessages } from './constants';

interface TaxInvoiceActionsProps {
  company: Company | null;
  isGenerating: boolean;
  t: TaxInvoiceTranslations;
  onCancel: () => void;
  onGenerate: () => void;
}

export function TaxInvoiceActions({
  company,
  isGenerating,
  t,
  onCancel,
  onGenerate
}: TaxInvoiceActionsProps) {
  // #522: 15 locale 전수 lookup — Locale 단일 출처 정합.
  const { locale } = useLanguage();
  const loadingMessage = loadingMessages[locale];

  return (
    <>
      <div className="flex gap-3">
        <Button
          variant="outline"
          onClick={onCancel}
          className="flex-1"
          disabled={isGenerating}
        >
          {t.cancel}
        </Button>
        <Button
          onClick={onGenerate}
          disabled={!company || isGenerating}
          className="flex-1 bg-blue-600 hover:bg-blue-700 text-white disabled:bg-gray-300"
        >
          {isGenerating ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              {t.generating}
            </>
          ) : (
            <>
              <FileText className="w-4 h-4 mr-2" />
              {t.generateInvoice}
            </>
          )}
        </Button>
      </div>

      {isGenerating && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-center gap-3">
            <Loader2 className="w-5 h-5 text-blue-600 animate-spin" />
            <div>
              <p className="text-sm font-medium text-blue-900">
                {loadingMessage.title}
              </p>
              <p className="text-xs text-blue-700">
                {loadingMessage.subtitle}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
